import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "safari-plug" }
const _hoisted_2 = { class: "buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      class: "logo",
      src: "/assets/logo.svg"
    }, null, -1 /* HOISTED */)),
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Unsupported Browser", -1 /* HOISTED */)),
    _cache[6] || (_cache[6] = _createElementVNode("p", null, [
      _createTextVNode(" Browsers using the Safari engine (WebKit) are not supported. "),
      _createElementVNode("br"),
      _createTextVNode(" Please use a Chromium-based browser (e.g., Google Chrome, Edge) or Firefox. ")
    ], -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        primary: "",
        onClick: _cache[0] || (_cache[0] = $event => ($options.open('https://www.google.com/chrome/')))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Download Google Chrome")
        ])),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Button, {
        primary: "",
        onClick: _cache[1] || (_cache[1] = $event => ($options.open('https://www.mozilla.org/en-US/firefox/new/')))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Download Mozilla Firefox")
        ])),
        _: 1 /* STABLE */
      })
    ])
  ]))
}